exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.valid-error .ant-select-selection__placeholder{\n  color: #f5222d;\n}\n.login-copyright {\n  text-align: center;\n  margin-top: 20px\n}\n.login-copyright, .login-copyright a {\n  color: #666\n}\n", ""]);

// exports
